import { render, staticRenderFns } from "./internetMark.vue?vue&type=template&id=2ee9238a&scoped=true&"
import script from "./internetMark.vue?vue&type=script&lang=js&"
export * from "./internetMark.vue?vue&type=script&lang=js&"
import style0 from "./internetMark.vue?vue&type=style&index=0&id=2ee9238a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee9238a",
  null
  
)

export default component.exports